import { useEffect, useState } from "react";
import { getOpenStatus } from "@/lib/constants";

export default function OpenBadge({ className = "" }) {
  const [status, setStatus] = useState(() => getOpenStatus());

  useEffect(() => {
    const id = setInterval(() => setStatus(getOpenStatus()), 60000);
    return () => clearInterval(id);
  }, []);

  return (
    <span
      data-testid="open-status-badge"
      className={`inline-flex items-center gap-2 whitespace-nowrap border px-3.5 py-2 text-[10px] font-medium uppercase tracking-[0.16em] ${
        status.open
          ? "border-emerald-400/30 bg-emerald-400/10 text-emerald-300"
          : "border-[#D4AF37]/40 bg-[#D4AF37]/10 text-[#F3E5AB]"
      } ${className}`}
    >
      <span
        className={`h-1.5 w-1.5 shrink-0 rounded-full ${
          status.open ? "animate-pulse bg-emerald-400" : "bg-[#D4AF37]"
        }`}
      />
      {status.label}
    </span>
  );
}
